import React from 'react';
import { Icon } from '@iconify/react';

export function Calendar() {
    const current = new Date();
    const todays_date = `${current.getDate()}`;
    
        return (    
        <div className="calendar">
                <div className="calendar-head">
                <div className="Dayname">Fr</div>
                <div className="Month">Dezemeber</div>
                    <div className="circle"> {todays_date}</div>
                        <button className="addevent-button">
                            <Icon icon="bi:plus-circle-fill" color="#0073cc" toggle-width="50" height="50" /></button>
                    <div className="head-right">
                        <button className="toggle-week-button">Woche</button>
                        <button className="arrow-left">
                            <Icon icon="cil:caret-top" />
                        </button>
                        <button className="arrow-right">
                            <Icon icon="cil:caret-top" />
                        </button>

                    <button className="calendaricon-button">
                        <Icon icon="material-symbols:calendar-month-outline-sharp" color="#0073cc" width="19.69" height="18.05" />
                    </button>
                </div>
            </div><div className="calendar-body">
                    <a href='./ModuleOverview'>
                    <button className="Module-Link"> 
                        IT- Projektseminar 1 <br /><br /> Uhrzeit: 09:00 - 11:30 <br /> Raum: R 0.005
                    </button>
                    </a>
                    <div className="eventsqaure2"> </div>

                    <hr className="hlinelong" />

                    <hr className="timeline" />

                    <div className="vline"></div>

                    <div className="timestamp">01:00</div>
                    <hr className="hline" />

                    <div className="timestamp">02:00</div>
                    <hr className="hline" />

                    <div className="timestamp">03:00</div>
                    <hr className="hline" />

                    <div className="timestamp">04:00</div>
                    <hr className="hline" />

                    <div className="timestamp">05:00</div>
                    <hr className="hline" />

                    <div className="timestamp">06:00</div>
                    <hr className="hline" />

                    <div className="timestamp">07:00</div>
                    <hr className="hline" />

                    <div className="timestamp">08:00</div>
                    <hr className="hline" />

                    <div className="timestamp">09:00</div>
                    <hr className="hline" />

                    <div className="timestamp">10:00</div>
                    <hr className="hline" />

                    <div className="timestamp">11:00</div>
                    <hr className="hline" />

                    <div className="timestamp">12:00</div>
                    <hr className="hline" />

                    <div className="timestamp">13:00</div>
                    <hr className="hline" />

                    <div className="timestamp">14:00</div>
                    <hr className="hline" />

                    <div className="timestamp">15:00</div>
                    <hr className="hline" />

                    <div className="timestamp">16:00</div>
                    <hr className="hline" />

                    <div className="timestamp">17:00</div>
                    <hr className="hline" />

                    <div className="timestamp">18:00</div>
                    <hr className="hline" />

                    <div className="timestamp">19:00</div>
                    <hr className="hline" />

                    <div className="timestamp">20:00</div>
                    <hr className="hline" />

                    <div className="timestamp">21:00</div>
                    <hr className="hline" />

                    <div className="timestamp">22:00</div>
                    <hr className="hline" />

                    <div className="timestamp">23:00</div>
                    <hr className="hline" />

                    <div className="timestamp">24:00</div>

                    <hr className="hline" />


                </div>

            </div>
            )
    } 
